<template>
	<TypographyTitle :level="2">
		{{ $t('login.header') }}
	</TypographyTitle>

	<div class="form-background max-width-750">
		<Form
			:model="formState"
			name="basic"
			:label-col="{ span: 8 }"
			:wrapper-col="{ span: 16 }"
			autocomplete="off"
			@finish="onFinish"
		>
			<FormItem
				:label="$t('login.form.username')"
				name="username"
				:rules="[{ required: true, message: $t('login.validators.username') }]"
			>
				<Input v-model:value="formState.username" ref="usernameField" />
			</FormItem>

			<FormItem
				:label="$t('login.form.password')"
				name="password"
				:rules="[{ required: true, message: $t('login.validators.password') }]"
			>
				<InputPassword v-model:value="formState.password" />
			</FormItem>

			<FormItem :wrapper-col="{ xs: { span: 24 }, sm: { offset: 8, span: 16 } }">
				<Button type="primary" html-type="submit" :disabled="isLoading" :loading="isLoading">{{ $t('login.form.submitButtonLabel') }}</Button>
			</FormItem>

			<FormItem :wrapper-col="{ xs: { span: 24 }, sm: { offset: 8, span: 16 } }" class="no-mg">
				<router-link :to="{ name: 'registration' }">{{ $t('login.registrationLink') }}</router-link> {{ $t('login.registrationText') }}
			</FormItem>
		</Form>
	</div>
</template>

<script>
import { reactive, ref } from 'vue';
import { TypographyTitle, Form, FormItem, Input, InputPassword, Button } from 'ant-design-vue';

import { useRouter } from 'vue-router';

import { useFocusOnMounted } from '@/utils/useFocusOnMounted';
import { showErrorMessage } from '@/components/common/errorMessage';

import Api from '@/api/Api';

export default {
	components: {
		TypographyTitle, Form, FormItem, Input, InputPassword, Button,
	},
	setup() {
		const formState = reactive({
			username: '',
			password: '',
		});
		const isLoading = ref(false);
		const router = useRouter();
		const onFinish = values => {
			isLoading.value = true;
			Api.getToken(
				values.username,
				values.password,
				() => {
					isLoading.value = false;
					router.push({ name: 'home' });
				},
				error => {
					isLoading.value = false;
					showErrorMessage(error.response.data);
				},
			);
		}

		const usernameField = ref();
		useFocusOnMounted(usernameField);
		return {
			formState,
			isLoading,
			onFinish,
			usernameField,
		};
	}
}
</script>
